import React from 'react';
import { Data, DataState } from '../../types/data-providers';
import * as SiteManager from '../domain/site-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useSelector } from 'react-redux';
import { Selectors } from '../../selectors';

//type ContextState = Data<DeviceTrendData>;
type TrendData = Array<{
    id: number;
    channelName: string;
    deviceId: string;
    deviceName: string;
    value: Array<{ dateTime: string; value: string }>;
    unit: string | null;
}>;
type DeviceTrendData = {
    trendData: Data<any>;
    fetchTrendData: Function;
};

const Context = React.createContext<DeviceTrendData | null>(null);

function useDeviceTrendData(): DeviceTrendData {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceTrendData must be used within a DeviceTrendDataProvider');
    }
    return contextState;
}

const DeviceTrendDataProvider: React.FC<{ deviceId: string; deviceName: string }> = (props) => {
    const authHelper = useAuthHelper();
    const days = useSelector(Selectors.Dashboard.deviceTrendCardDays);
    const [trendData, setTrendData] = React.useState<Data<any>>({ state: DataState.Loading });

    const deviceTrendResult = React.useCallback(
        async (channels: number[], daysChanged?: number) => {
            const daysData = daysChanged ? daysChanged : days;
            setTrendData({
                state: DataState.Loading,
            });
            const data = await SiteManager.getDeviceTrendData(
                authHelper,
                props.deviceId,
                props.deviceName,
                channels,
                daysData
            );
            return data;
        },
        [authHelper, props.deviceId, props.deviceName, days]
    );

    const fetchTrendData = React.useCallback(
        async (channels: number[], selectedDays?: number): Promise<TrendData> => {
            // React.useCallback(
            //     (): Promise<TrendData> => SiteManager.getTrendData(authHelper, props.siteId, days),
            //     [props.siteId, authHelper, days]
            // ),

            const data = await deviceTrendResult(channels, selectedDays);

            setTrendData({
                state: DataState.Loaded,
                value: data,
            });

            return data;
        },
        [deviceTrendResult]
    );

    return <Context.Provider value={{ trendData, fetchTrendData }}>{props.children}</Context.Provider>;
};

const TestTrendDataProvider: React.FC<{ value: DeviceTrendData }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceTrendDataProvider, TestTrendDataProvider, useDeviceTrendData };
